import { useSelector } from 'react-redux';
import { useEffect, useContext } from 'react';
import { UserContext } from 'contexts/UserContext';
import { useNavigate } from 'react-router-dom';

const AuthGuard = ({ children }) => {
  const account = useSelector((state) => state.account);
  const { isUserLoaded } = useContext(UserContext);
  const navigate = useNavigate();
  useEffect(() => {
    if (isUserLoaded && !account.user) {  // 如果用户数据加载完成，但没有用户信息
      navigate('/login');                 // 跳转到 /login 登录页面
      return;
    }
  }, [account, navigate, isUserLoaded]);// 依赖项变化时会重新执行

  return children;
};

export default AuthGuard;
